import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material";
import { Observable } from "rxjs";
import { CodeTable } from "src/app/core/model/v2/code-table";
import { StaffDetails } from "src/app/core/model/v2/practice/staffDetails";
import { UserSetup } from "src/app/core/model/v2/practitioner/UserSetup";
import { CommonService } from "src/app/core/services/v2/common.service";
import { StaffService } from "src/app/core/services/v2/staff.service";
import { SideBarComponentInterface } from "src/app/shared/components/dynamic-right-sidebar/sideBarComponentInterface";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";

@Component({
  selector: "app-practice-manager-form",
  templateUrl: "./practice-manager-form.component.html",
  styleUrls: ["./practice-manager-form.component.scss"],
})
export class PracticeManagerFormComponent implements OnInit {
  @Input() practiceManagerData;
  @Output() toggleSidebar = new EventEmitter();
  statesCodes: CodeTable;
  practiceManager: StaffDetails = new StaffDetails();
  constructor(
    private staffService: StaffService,
    private commonService: CommonService,
    private loaderService: WindowLoaderService,
    private _matSnackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getSates();
    this.healthSystemId = this.practiceManagerData.hsId;
    this.buildpracticeManagerObject(
      this.practiceManagerData.practiceManagerData
    );
  }
  healthSystemId: number;
  title: string = "Practice Manager";
  errorMessage: string;

  nameFormControl = new FormControl("", [Validators.required]);
  phoneFormControl = new FormControl("", [Validators.required]);
  faxFormControl = new FormControl("", []);
  roleFormControl = new FormControl("", [Validators.required]);
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  address1FormControl = new FormControl("", [Validators.required]);
  address2FormControl = new FormControl("", []);
  cityFormControl = new FormControl("", [Validators.required]);
  stateFormControl = new FormControl("", [Validators.required]);
  zipFormControl = new FormControl("", [Validators.required]);

  dataForm: FormGroup = new FormGroup({
    name: this.nameFormControl,
    phone: this.phoneFormControl,
    fax: this.faxFormControl,
    role: this.roleFormControl,
    email: this.emailFormControl,
    address1: this.address1FormControl,
    address2: this.address2FormControl,
    city: this.cityFormControl,
    state: this.stateFormControl,
    zip: this.zipFormControl,
  });

  buildpracticeManagerObject(practiceManager: UserSetup): void {
    if (practiceManager) {
      this.practiceManager = new StaffDetails();
      this.practiceManager.staffUserId = practiceManager.id;
      this.practiceManager.name = practiceManager.name;
      this.practiceManager.email = practiceManager.email;
      this.practiceManager.phoneNumber = practiceManager.phoneNumber;
      this.practiceManager.role = practiceManager.role;
      this.practiceManager.address = practiceManager.address;
      this.practiceManager.healthSystemIds = practiceManager.healthSystemIds;
      this.practiceManager.address = practiceManager.address;
    }
  }

  getSates() {
    this.commonService.GetItemsByCodeNamesWithoutCache(["STATE"]).subscribe(
      (codeTables) => {
        this.statesCodes = codeTables.codeTable[0];
      },
      (error) => console.log(error)
    );
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onSave() {
    this.loaderService.show();
    if (this.practiceManager.staffUserId > 0) {
      this.defaultResultSubscription(
        this.staffService.updateStaff(this.practiceManager)
      );
      this.toggleSidebar.emit();
      this.loaderService.hide();
    } else {
      this.defaultResultSubscription(
        this.staffService.createPracticeManager(
          this.practiceManager,
          this.healthSystemId
        )
      );
      this.toggleSidebar.emit();
      this.loaderService.hide();
    }
  }

  defaultResultSubscription(requestResponse: Observable<any>) {
    requestResponse.subscribe(
      (response) => {
        if (response.isSuccess) {
          this.commonService.closeRightSideBar$.next();
        } else {
          this.loaderService.hide();
          // this.errorMessage = 'Error: ' + response.message;

          this._matSnackBar.open(response.message, "Ok");
        }
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
        this._matSnackBar.open(error.error.message, "Ok");
      }
      // ,
      // () => this.loaderService.hide()
    );
  }

  deletePracticeManager() {
    this.loaderService.show();
    this.defaultResultSubscription(
      this.staffService.removePracticeManager(this.healthSystemId)
    );
    this.toggleSidebar.emit();
  }
}
